import EstimatorChecklistContainer from '../../containers/estimator-checklist/EstimatorChecklistContainer';

const EstimatorChecklistDefaults = () => {
  return <EstimatorChecklistContainer />;
};

export default EstimatorChecklistDefaults;
